export const calcEmFromPx = (size: number, base = 16) => size / base;
export const pxToRem = (size: number, base = 16) => `${size / base}rem`;
